import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20manga%20style%20illustration%20with%20warm%20golden%20and%20deep%20crimson%20gradients%2C%20floating%20ink%20brush%20strokes%2C%20soft%20glowing%20particles%2C%20Japanese%20aesthetic%20wave%20patterns%2C%20elegant%20composition%2C%20dramatic%20lighting%2C%20no%20text&width=1800&height=800&seq=hero-manga-bg-2026&orientation=landscape"
          alt="黄漫天堂"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white font-heading mb-4 tracking-wide">
          黄漫天堂
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mb-4 leading-relaxed">
          汇聚海量黄漫资源分类推荐、热门作品排行、新作速递与创作者专区
        </p>
        <p className="text-sm md:text-base text-white/60 max-w-xl mb-8">
          无论你是资深漫画迷还是新手入门，都能在这里快速找到心仪内容，畅享极致漫画体验
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/all"
            className="px-8 py-3 rounded-lg bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-compass-3-line mr-2"></i>开始探索
          </Link>
          <Link
            to="/#ranking"
            className="px-8 py-3 rounded-lg border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-fire-line mr-2"></i>热门排行
          </Link>
        </div>
        <div className="flex items-center gap-6 mt-10 text-white/50 text-xs md:text-sm">
          <span className="flex items-center gap-1.5">
            <span className="text-accent-400 font-bold text-base">1,256+</span>
            <span>精彩作品</span>
          </span>
          <span className="w-px h-4 bg-white/20"></span>
          <span className="flex items-center gap-1.5">
            <span className="text-accent-400 font-bold text-base">9+</span>
            <span>内容分类</span>
          </span>
          <span className="w-px h-4 bg-white/20"></span>
          <span className="flex items-center gap-1.5">
            <span className="text-accent-400 font-bold text-base">50+</span>
            <span>签约创作者</span>
          </span>
          <span className="w-px h-4 bg-white/20"></span>
          <span className="flex items-center gap-1.5">
            <span className="text-accent-400 font-bold text-base">500万+</span>
            <span>月活跃用户</span>
          </span>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}